import styles from "./NotFound.module.css";

export default function NotFound() {
    return (
        <div className={styles.container}>
            <h1 className={styles.h1}>404 – Stránka nenalezena</h1>
            <p className={styles.p}>Tato adresa neexistuje.</p>
            <a className={styles.a} href="/">Zpět na hlavní stránku</a>
        </div>
    );
}